import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="bg-light text-dark pt-5 pb-4">
            <div className="container">
                <div className="row">

                    <div className="col-md-3 mb-4">
                        <img src="/assets/penta-logo.png" alt="logo" style={{ maxWidth: "200px" }} className='mb-4' />
                        <p><strong>Mail:</strong> pentadeco@gmail.com</p>
                        <p><strong>Phone:</strong> <br />
                            +917738494171 <br />
                            +918433551012 <br />
                            +919273158535
                        </p>
                    </div>

                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold">QUICK LINKS</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/" className="text-dark text-decoration-none">Home</Link></li>
                            <li><Link to="/about" className="text-dark text-decoration-none">About</Link></li>
                            <li><Link to="/products" className="text-dark text-decoration-none">Products</Link></li>
                            <li><Link to="/cart" className="text-dark text-decoration-none">Cart</Link></li>
                            <li><Link to="/orders" className="text-dark text-decoration-none">Orders</Link></li>
                            <li><Link to="/contact" className="text-dark text-decoration-none">Contact us</Link></li>
                        </ul>
                    </div>

                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold">QUICK SHOP</h6>
                        <ul className="list-unstyled">
                            <li><Link to="#" className="text-dark text-decoration-none">Home Decor</Link></li>
                            <li><Link to="#" className="text-dark text-decoration-none">Kitchen Decor</Link></li>
                            <li><Link to="#" className="text-dark text-decoration-none">Mugs & Bottles</Link></li>
                            <li><Link to="#" className="text-dark text-decoration-none">Personal Accessory</Link></li>
                        </ul>
                    </div>

                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold">CUSTOMER SERVICES</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/disclaimer" className="text-dark text-decoration-none">Disclaimer</Link></li>
                            <li><Link to="/terms-and-conditions" className="text-dark text-decoration-none">Terms & Conditions</Link></li>
                            <li><Link to="/privacy-policy" className="text-dark text-decoration-none">Privacy Policy</Link></li>
                            <li><Link to="/return-and-refund-policy" className="text-dark text-decoration-none">Return & Refund</Link></li>
                        </ul>
                    </div>

                    <div className="col-md-3 mb-4">
                        <h6 className="fw-bold">ADDRESS</h6>
                        <p>Flat no. 102, J Wing, Sai Plush Apartment, DK Home, Kon, Kalyan, Kongaon, Maharashtra 421311</p>
                        <div className="mt-3">
                            <a href="https://instagram.com/" className="text-dark me-3"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://instagram.com/" className="text-dark me-3"><i className="fab fa-instagram"></i></a>
                            <a href="https://instagram.com/" className="text-dark me-3"><i className="fab fa-twitter"></i></a>
                            <a href="https://instagram.com/" className="text-dark me-3"><i className="fab fa-youtube"></i></a>
                            <a href="https://instagram.com/" className="text-dark"><i className="fab fa-pinterest-p"></i></a>
                        </div>
                    </div>
                </div>

                <div className="border-top pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
                    <p className="mb-2 mb-md-0 fs-sm">&copy; 2025 Pentadeco. All Rights Reserved.</p>
                    <div className="d-flex flex-wrap align-items-center">
                        <select className="form-select form-select-sm me-2" style={{ width: 'auto' }}>
                            <option selected>English</option>
                            <option>Hindi</option>
                        </select>
                        <select className="form-select form-select-sm me-3" style={{ width: 'auto' }}>
                            <option selected>USD</option>
                            <option>INR</option>
                        </select>
                        <span className="me-2">Payment:</span>
                        <div className="payment-icons d-flex align-items-center">
                            <img src="https://img.icons8.com/color/30/visa.png" alt="Visa" />
                            <img src="https://img.icons8.com/color/30/mastercard.png" alt="MasterCard" />
                            <img src="https://img.icons8.com/color/30/amex.png" alt="Amex" />
                            <img src="https://img.icons8.com/color/30/paypal.png" alt="PayPal" />
                            <img src="https://img.icons8.com/color/30/discover.png" alt="Discover" />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
